<template lang="pug">
div
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="spanSize")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Denominação")
        app-label(:label="labelsCadastro.imovel.denominacao", :required="required")
        el-input.input(
          v-model="imovel.denominacao",
          :name='labelsCadastro.imovel.denominacao.colonia',
          maxlength="300"
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="spanSize" v-if="tipoCadastro === 'CANCELAMENTO_CLAUSULA_RESOLUTIVA'")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/gleba")
        app-label(:label="labelsCadastro.imovel.colonia", :required="required")
        el-input.input(
          v-model="imovel.gleba",
          :name='labelsCadastro.imovel.gleba',
          maxlength="300"
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="spanSize")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Município")
        app-label( label="Município:", :required="required")
        el-select.input(
          class="select",
          v-model="imovel.municipio",
          no-match-text="Nenhum Município Encontrado",
          placeholder="Selecione",
          filterable,
          clearable,
          @clear="imovel.municipio = null"
          value-key="id",
          name="Município",
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="item in municipios",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )
        span.help.erro {{ errors[0] }}

    el-col.inputDiv(:span="spanSize")
      validation-provider(:rules="isRequiredArea", v-slot="{ errors }", name="Imóvel/Área")
        app-label(label="Área:", :required="required")
        app-double-input.input(
          v-model="imovel.area",
          name='Área',
          :precision="4",
          :onkeypress="onlyInputNumbers",
          :class="{'erro' : errors.length}",
          :showAppend ="true",
          @areaString='areaChange($event)'
        )
        span.help.erro {{ errors[0] }}

  div(v-if="tipoCadastro === 'INFORMACOES'")
    el-row(:gutter="30")
      el-col.inputDiv(:span="8")
        validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Nome da Colônia")
          app-label(:label="labelsCadastro.imovel.colonia", :required="required")
          el-input.input(
            v-model="imovel.nomeColonia",
            maxlength="300"
            :name='labelsCadastro.imovel.colonia',
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}

    el-row(:gutter="30")
      el-col(:span="24")
        validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Localização")
          app-label(label="Localização:", :required="required")
          el-input.input(
            v-model="imovel.localizacao",
            name='Localização',
            type="textarea",
            :rows="5",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}

</template>
<script>
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import AppDoubleInput from '@/components/AppDoubleInput'
const {labelsCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  mixins: [onlyInputNumbers],
  components: {
    AppDivider,
    AppLabel,
    AppDoubleInput
  },
  props: {
    imovel: {
      required: true
    },

    // prop que define se os campos são obrigatorios
    required: {
      type: Boolean,
      default: true
    },

    tipoCadastro: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      labelsCadastro,
      municipios: []
    }
  },
  created () {
    this.getMunicipiosByUf()
  },

  computed: {
    isRequired () {
      return this.required ? 'required' : ''
    },
    isRequiredArea () {
      return this.required ? 'required|min_value:0.00001' : ''
    },
    spanSize () {
      return this.tipoCadastro === 'CANCELAMENTO_CLAUSULA_RESOLUTIVA' ? 6 : 8
    }
  },

  methods: {
    async getMunicipiosByUf () {
      this.municipios = await this.$store.dispatch(`municipios/findMunicipiosByUf`, process.env.ESTADO)
    },
    areaChange (area) {
      if (this.tipoCadastro === 'CANCELAMENTO_CLAUSULA_RESOLUTIVA') {
        this.imovel.areaString = area
      }
    },
    onSemNumeroCheck (checked) {
      if (checked) {
        this.imovel.numero = 0
        return
      }

      this.imovel.numero = null
    }
  }
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
.select {
  width: 100%;
}

@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }
  .inputDiv {
    width: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/cadastro/AppImovelDenominacao.vue